import React from "react";
import './student-logout-report.scss';
import SchoolApi from "../../apis/school";
import DateRangePicker from 'react-bootstrap-daterangepicker';
import Dropdown from '../common/dropdown-v2/dropdown';
import Loading from "../common/loading/loading";
import { getImageSource } from "../../utility/image-source";
import { ImageConstants } from "../../constants/constants";

const HH_OPTIONS = Array.from({length: 12}, (_, i) => {
    let v = (i + 1).toString().padStart(2, '0');
    return { title: v, value: v };
});
const MM_OPTIONS = Array.from({length: 60}, (_, i) => {
    let v = i.toString().padStart(2, '0');
    return { title: v, value: v };
});
const AMPM_OPTIONS = [
    { title: 'AM', value: 'AM' },
    { title: 'PM', value: 'PM' }
];

class TimePicker extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hh: "",
            mm: "",
            ampm: "AM"
        };
    }

    componentDidMount() {
        if (this.props.value) {
            let match = this.props.value.match(/(\d+):(\d+)\s*(AM|PM)/i);
            if (match) {
                this.setState({ hh: match[1], mm: match[2], ampm: match[3].toUpperCase() });
            }
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.value !== this.props.value && !this.props.value) {
            this.setState({ hh: "", mm: "", ampm: "AM" });
        }
    }

    handleChange = (type, option) => {
        let val = option ? option.value : "";
        this.setState({ [type]: val }, () => {
            let { hh, mm, ampm } = this.state;
            if (!hh || !mm) {
                this.props.onChange('');
            } else {
                this.props.onChange(`${hh}:${mm} ${ampm}`);
            }
        });
    };

    render() {
        let { hh, mm, ampm } = this.state;
        return (
            <div style={{ display: 'flex', gap: '5px', flex: 1 }}>
                <div style={{ flex: 1, minWidth: '60px' }}>
                    <Dropdown 
                        placeholder="HH" 
                        options={HH_OPTIONS} 
                        onSelect={opt => this.handleChange('hh', opt)} 
                        text="title" 
                        value={hh} 
                    />
                </div>
                <div style={{ flex: 1, minWidth: '60px' }}>
                    <Dropdown 
                        placeholder="MM" 
                        options={MM_OPTIONS} 
                        onSelect={opt => this.handleChange('mm', opt)} 
                        text="title" 
                        value={mm} 
                    />
                </div>
                <div style={{ flex: 1, minWidth: '70px' }}>
                    <Dropdown 
                        placeholder="AM/PM" 
                        options={AMPM_OPTIONS} 
                        onSelect={opt => this.handleChange('ampm', opt)} 
                        text="title" 
                        value={ampm} 
                    />
                </div>
            </div>
        );
    }
}

class StudentLogoutReport extends React.Component {

    state = {
        boardsDropdownItems: [],
        classDropdownItems: [],
        sectionsDropdownItems: [],
        subjectsDropdownItems: [],
        selectedBoard: '',
        selectedClass: '',
        selectedSection: '',
        selectedSubject: '',
        selectedCreatedDateRange: '',
        timeRangeStart: '',
        timeRangeEnd: '',
        isLoading: false,
        reportData: [],
        hasFetchedData: false,
        selectedTimelineStudent: null,
        showTimelineModal: false
    };

    handleTimeChange = (e, type) => {
        this.setState({ [type]: e.target.value });
    }

    componentDidMount() {
        this.getClassAndBoards();
        this.getSections();
        this.checkLocationStateAndFetch();
    }

    componentDidUpdate(prevProps) {
        if (this.props.location?.state !== prevProps.location?.state && this.props.location?.state?.autoFetch) {
            this.checkLocationStateAndFetch();
        }
    }

    checkLocationStateAndFetch() {
        const locationState = this.props.location?.state;
        if (locationState) {
            let hwId = locationState.homeworkId || locationState.id || locationState._id || '';
            if (typeof hwId === 'object') {
                hwId = hwId.$oid || (hwId.toString ? hwId.toString() : '');
            }
            if (hwId === '[object Object]') hwId = '';

            this.setState({
                selectedBoard: locationState.board || '',
                selectedClass: locationState.class || '',
                selectedSection: locationState.section || '',
                selectedSubject: locationState.subject || '',
                selectedChapter: locationState.chapter || '',
                homeworkId: hwId
            }, () => {
                this.fetchReportData();
            });
        } else {
            this.fetchReportData();
        }
    }

    getClassAndBoards() {
        SchoolApi.getClassAndBoard()
            .then(res => {
                let boards = (res.boards || []).map(b => ({ title: b.name, value: b.id || b.name }));
                let classes = (res.classes || []).map(c => ({ title: c.name, value: c.id || c.name }));
                this.setState({
                    boardsDropdownItems: boards,
                    classDropdownItems: classes,
                    selectedBoard: '',
                    selectedClass: ''
                })
            }).catch(err => {
                console.log(err)
            })
    }


    getSections() {
        SchoolApi.getSections()
            .then(res => {
                let allSections = res.response || res.sections || [];
                let uniqueSectionNames = Array.from(new Set(allSections.map(s => s.section || s.name).filter(Boolean)));
                
                let sections = uniqueSectionNames.map(name => ({ 
                    title: name, 
                    value: name 
                }));
                
                this.setState({
                    sectionsDropdownItems: sections,
                    selectedSection: ''
                })
            }).catch(err => {
                console.log(err)
            })
    }

    handleCreatedDateEvent = (event, picker) => {
        this.createdDateRangeStart = new Date(picker.startDate);
        this.createdDateRangeEnd = new Date(picker.endDate).toLocaleDateString() === new Date().toLocaleDateString() ? new Date() : new Date(picker.endDate);
        this.setState({ 
            selectedCreatedDateRange: this.createdDateRangeStart.toLocaleDateString() + "  -  " + this.createdDateRangeEnd.toLocaleDateString() 
        });
    }

    onSelectDropDown = (option, key) => {
        this.setState({ [key]: option?.value });
    }

    downloadReport = () => {
        let payload = {
            board: this.state.selectedBoard,
            class: this.state.selectedClass,
            dateRangeStart: this.createdDateRangeStart ? this.createdDateRangeStart.toISOString() : undefined,
            dateRangeEnd: this.createdDateRangeEnd ? this.createdDateRangeEnd.toISOString() : undefined,
            timeRangeStart: this.state.timeRangeStart || undefined,
            timeRangeEnd: this.state.timeRangeEnd || undefined,
            section: this.state.selectedSection,
            homeworkId: this.state.homeworkId || undefined,
            chapter: this.state.selectedChapter || undefined
        };

        this.setState({ isLoading: true });

        SchoolApi.getStudentLogoutReport(payload)
            .then(res => {
                this.setState({ isLoading: false });
                
                const blob = new Blob([res], { type: 'text/csv' });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.style.display = 'none';
                a.href = url;
                a.download = 'student-logout-report.csv';
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
                document.body.removeChild(a);

            }).catch(err => {
                console.log(err);
                this.setState({ isLoading: false });
                alert("Error downloading report.");
            });
    }

    fetchReportData = () => {
        let payload = {
            board: this.state.selectedBoard,
            class: this.state.selectedClass,
            dateRangeStart: this.createdDateRangeStart ? this.createdDateRangeStart.toISOString() : undefined,
            dateRangeEnd: this.createdDateRangeEnd ? this.createdDateRangeEnd.toISOString() : undefined,
            timeRangeStart: this.state.timeRangeStart || undefined,
            timeRangeEnd: this.state.timeRangeEnd || undefined,
            section: this.state.selectedSection,
            homeworkId: this.state.homeworkId || undefined,
            chapter: this.state.selectedChapter || undefined
        };

        this.setState({ isLoading: true });

        SchoolApi.getStudentLogoutReportData(payload)
            .then(res => {
                this.setState({ 
                    isLoading: false,
                    reportData: res || [],
                    hasFetchedData: true
                });
            }).catch(err => {
                console.log(err);
                this.setState({ isLoading: false });
                alert("Error fetching report data.");
            });
    }

    getKpiMetrics = () => {
        let data = this.state.reportData || [];
        let totalLogouts = 0;
        let totalSessions = 0;
        let totalDurSec = 0;
        let durCount = 0;
        let electronCount = 0;
        let totalLogsCount = 0;
        let uniqueStudents = new Set();

        data.forEach(row => {
            if (row.name) uniqueStudents.add(row.name);
            totalLogouts += (row.totalLogouts !== undefined ? row.totalLogouts : row.count || 0);
            totalSessions += (row.totalSessions !== undefined ? row.totalSessions : 1);
            
            if (row.sessionLogs && row.sessionLogs.length) {
                row.sessionLogs.forEach(s => {
                    totalLogsCount++;
                    if (s.isElectron) electronCount++;
                    if (s.durationSeconds > 0) {
                        totalDurSec += s.durationSeconds;
                        durCount++;
                    }
                });
            }
        });

        let avgDurSec = durCount > 0 ? Math.round(totalDurSec / durCount) : 0;
        let avgDurText = avgDurSec > 60 ? `${Math.floor(avgDurSec / 60)}m ${avgDurSec % 60}s` : `${avgDurSec}s`;
        let electronPct = totalLogsCount > 0 ? Math.round((electronCount / totalLogsCount) * 100) : 100;

        return {
            totalLogouts,
            uniqueStudentsCount: uniqueStudents.size,
            avgDurText,
            electronPct
        };
    };

    renderTimelineModal = () => {
        let student = this.state.selectedTimelineStudent;
        if (!student) return null;

        let sessions = student.sessionLogs || [];

        return (
            <div className="timeline-modal-backdrop" onClick={() => this.setState({ showTimelineModal: false, selectedTimelineStudent: null })}>
                <div className="timeline-modal-dialog" onClick={(e) => e.stopPropagation()}>
                    <div className="timeline-modal-header">
                        <div className="modal-title">
                            Session & Logout Timeline: <strong>{student.name}</strong>
                        </div>
                        <button className="close-btn" onClick={() => this.setState({ showTimelineModal: false, selectedTimelineStudent: null })}>
                            &times;
                        </button>
                    </div>
                    <div className="timeline-modal-body">
                        <div className="mb-3 text-muted" style={{ fontSize: '13px' }}>
                            <span><strong>Class:</strong> {student.class} {student.section}</span> | <span><strong>Date:</strong> {student.date}</span>
                        </div>

                        {sessions.length > 0 ? (
                            <div className="timeline-flow">
                                {sessions.map((item, idx) => {
                                    let status = (item.status || item.startStatus || 'LOGOUT').toUpperCase();
                                    let timeStr = item.timestampFormatted || item.startFormatted || item.logoutFormatted;

                                    let badgeClass = 'badge-logout';
                                    if (status === 'START') badgeClass = 'badge-start';
                                    else if (status === 'RESUME') badgeClass = 'badge-resume';
                                    else if (status === 'COMPLETED') badgeClass = 'badge-completed';
                                    else if (status === 'IN_PROGRESS') badgeClass = 'badge-progress';

                                    return (
                                        <div className="timeline-step" key={idx}>
                                            <div className="step-icon-dot">{idx + 1}</div>
                                            <div className="step-content" style={{ padding: '12px 16px' }}>
                                                <div className="step-header" style={{ margin: 0 }}>
                                                    <span className="step-time" style={{ fontWeight: '600', fontSize: '14px' }}>
                                                        {timeStr}
                                                    </span>
                                                    <span className={`badge-status ${badgeClass}`}>
                                                        {status}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        ) : (
                            <div className="text-center p-3 text-muted">
                                No detailed session timeline recorded for this entry.
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    };

    render() {
        const kpis = this.getKpiMetrics();

        return (
            <div className="student-logout-report px-3">
                {this.state.isLoading && <Loading />}
                {this.state.showTimelineModal && this.renderTimelineModal()}
                
                <div>
                    <img 
                        alt="Back" 
                        className='back-icon cursor-pointer mb-3' 
                        src={getImageSource(ImageConstants.BACK_ICON)} 
                        onClick={() => this.props.history ? this.props.history.goBack() : window.history.back()} 
                        style={{ cursor: 'pointer', height: '24px' }}
                    />
                </div>

                <div className="d-flex justify-content-between align-items-center mb-4">
                    <div className="school-name" style={{ fontSize: '24px', fontWeight: 'bold', color: '#2C3E50' }}>
                        Student Logout Report
                    </div>
                    <div className="d-flex">
                        <button 
                            className="cw-button" 
                            onClick={this.downloadReport} 
                            disabled={this.state.isLoading}
                            style={{ height: '40px', padding: '0 24px', borderRadius: '20px' }}
                        >
                            {this.state.isLoading ? 'DOWNLOADING...' : 'DOWNLOAD REPORT'}
                        </button>
                    </div>
                </div>

                {this.state.hasFetchedData && (
                    <div className="row mt-4">
                        <div className="col-12 px-4">
                             {this.state.reportData.length > 0 ? (
                                    <>
                                        <div className="case-study-skill-border-container">
                                            <div className="bordered-text">Details</div>
                                            <div className="d-flex align-items-center flex-wrap" style={{ gap: '20px' }}>
                                                {(this.state.selectedClass || this.state.reportData[0]?.class) && (
                                                    <div className="class-text pr-3 border-right-gray" style={{ fontSize: '15px', fontWeight: 'bold' }}>
                                                        {this.state.selectedClass || this.state.reportData[0]?.class}
                                                    </div>
                                                )}
                                                {(this.state.selectedSection || this.state.reportData[0]?.section) && (
                                                    <div className="class-text pr-3 border-right-gray" style={{ fontSize: '15px' }}>
                                                        Section {this.state.selectedSection || this.state.reportData[0]?.section}
                                                    </div>
                                                )}
                                                <div className="class-text" style={{ fontSize: '14px', color: '#555' }}>
                                                    Students: <strong>{kpis.uniqueStudentsCount}</strong>
                                                </div>
                                            </div>

                                            {(this.state.selectedSubject || this.state.selectedChapter) && (
                                                <div className="mt-3 pt-2" style={{ borderTop: '1px solid #EAEAEA' }}>
                                                    <div className="d-flex flex-wrap align-items-center" style={{ gap: '16px', fontSize: '14px' }}>
                                                        {this.state.selectedSubject && (
                                                            <div className="pr-3 border-right-gray">
                                                                <strong>Subject:</strong> {this.state.selectedSubject}
                                                            </div>
                                                        )}
                                                        {this.state.selectedChapter && (
                                                            <div>
                                                                <strong>Chapter(s):</strong> {this.state.selectedChapter}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            )}
                                        </div>

                                        <table className="table cw-table mb-0 align-items-center">
                                            <thead>
                                                <tr>
                                                    <th>Name</th>
                                                    <th>Date</th>
                                                    <th>Logouts</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.reportData.map((row, index) => (
                                                    <tr key={index}>
                                                        <td>{row.name}</td>
                                                        <td>{row.date}</td>
                                                        <td>
                                                            {row.logoutTimes && row.logoutTimes.length > 0 ? (
                                                                <span className="count-tooltip-wrapper">
                                                                    {row.totalLogouts !== undefined ? row.totalLogouts : row.count}
                                                                    <span className="count-tooltip">
                                                                        <strong>Logout Times</strong>
                                                                        {row.logoutTimes.map((t, i) => (
                                                                            <span key={i} className="count-tooltip-item">{t}</span>
                                                                        ))}
                                                                    </span>
                                                                </span>
                                                            ) : (
                                                                row.totalLogouts !== undefined ? row.totalLogouts : row.count
                                                            )}
                                                        </td>
                                                        <td>
                                                            <button 
                                                                className="view-timeline-btn"
                                                                onClick={() => this.setState({ showTimelineModal: true, selectedTimelineStudent: row })}
                                                            >
                                                                View Timeline
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </>
                            ) : (
                                <div className="text-center p-5">
                                    <h5>No data found for the selected filters.</h5>
                                </div>
                            )}
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default StudentLogoutReport;